import packageJson from "../../package.json";

export class AppConfig {
  static titleBase: string = "Előjegyzési Központ";
  static version: string = packageJson.version;

  static get production() {
    return import.meta.env.NODE_ENV === "development";
  }

  static get title() {
    return `${AppConfig.titleBase} ${
      AppConfig.production ? "" : import.meta.env.VITE_ENV_NAME
    }`;
  }

  static get titleVersion() {
    return `${AppConfig.titleBase} v${AppConfig.version} ${
      AppConfig.production ? "" : import.meta.env.VITE_ENV_NAME
    }`;
  }
}
